import { Injectable } from '@angular/core';

import { EditorView } from 'prosemirror-view';

import { EditorButton } from '@recruitee/prosemirror';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class ToolbarService {
  public contextButtons$: Observable<EditorButton[]>;
  public rightOutletButtons$: Observable<EditorButton[]>;
  public leftOutletButtons$: Observable<EditorButton[]>;

  private buttons: { context: EditorButton[]; left: EditorButton[]; right: EditorButton[] } = {
    context: [],
    left: [],
    right: [],
  };
  private additionalButtons: EditorButton[] = [];
  private contextButtons = new BehaviorSubject<EditorButton[]>([]);
  private rightOutletButtons = new BehaviorSubject<EditorButton[]>([]);
  private leftOutletButtons = new BehaviorSubject<EditorButton[]>([]);

  constructor() {
    this.contextButtons$ = this.contextButtons.asObservable();
    this.rightOutletButtons$ = this.rightOutletButtons.asObservable();
    this.leftOutletButtons$ = this.leftOutletButtons.asObservable();
  }

  public setContextButtons(context: EditorButton[]) {
    this.buttons = { ...this.buttons, context };
    this.contextButtons.next(context);
  }

  public setLeftButtons(left: EditorButton[]) {
    this.buttons = { ...this.buttons, left };
    this.leftOutletButtons.next(left);
  }

  public setRightButtons(right: EditorButton[]) {
    this.buttons = { ...this.buttons, right };
    this.rightOutletButtons.next([...this.additionalButtons, ...right]);
  }

  public setAdditionalButtons(buttons: EditorButton[]) {
    this.additionalButtons = buttons;
    this.rightOutletButtons.next([...buttons, ...this.buttons.right]);
  }
}
